import { api } from 'api'
import { stringify } from 'qs'

type GetUpcomingInvoicesResponseItem = {
  invoiceGroupKey: string[]
  invoiceGroup: string
  periodStart: string
  periodEnd: string
  cutoffAt: string
  weekStartDay: string
  weekTimezone: string
  estimateTotalCharge: string
  workCount: number
}

type GetUpcomingInvoicesResponse = {
  items: GetUpcomingInvoicesResponseItem[]
}

export type UpcomingInvoiceDetailItem = {
  description: string
  quantity: string
  unitAmount: string
  amount: string
  status: string
}

export type UpcomingInvoiceDetail = {
  invoiceGroupKey: string[]
  invoiceGroup: string
  periodStart: string
  periodEnd: string
  cutoffAt: string
  weekStartDay: string
  weekTimezone: string
  estimateTotalCharge: string
  items: UpcomingInvoiceDetailItem[]
}

export type GetUpcomingInvoiceDetailParams = {
  periodStart: string
  invoiceGroupKey: string[]
}

export async function getUpcomingInvoices(
  companyId: number,
  signal?: AbortSignal
) {
  const response = await api.get<GetUpcomingInvoicesResponse>(
    `/company/${companyId}/invoice_preview`,
    { signal }
  )
  return response.data.items
}

export async function getUpcomingInvoiceDetail(
  companyId: number,
  params: GetUpcomingInvoiceDetailParams,
  signal?: AbortSignal
) {
  const response = await api.get<UpcomingInvoiceDetail>(
    `/company/${companyId}/invoice_preview/items`,
    {
      params: {
        periodStart: params.periodStart,
        invoiceGroupKey: params.invoiceGroupKey,
      },
      paramsSerializer: (queryParams) =>
        stringify(queryParams, { arrayFormat: 'repeat', indices: false }),
      signal,
    }
  )
  return response.data
}

export async function getInvoicePreview(
  companyId: number,
  signal?: AbortSignal
) {
  const response = await api.get<string>(
    `/company/${companyId}/invoice_preview/csv`,
    {
      responseType: 'text',
      signal,
    }
  )

  return response.data
}
